import { Bound } from "lib/@components/binding/Bound"
import { usePayloadTask } from "routes/facilities/lib/use-payload-task"
import { useRefresh } from "lib/@hooks/useRefresh"
import { Different } from "routes/regime/components/different"
import { Time } from "routes/schedule/tasks/time"
import { Frequency } from "routes/schedule/tasks/frequency"
import { periodDuration } from "routes/schedule/lib/usePeriodTimingsPerTask"
import { SummaryDataChanged, TaskTailorChange } from "event-definitions"
import { BlockClicks } from "lib/@components/block-clicks"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { Payload } from "routes/schedule/controller/payload"
import { assessStatus } from "routes/schedule/assess-status"

export function EditTimings() {
    const { target, schedule, payload } = useBoundContext()
    const task = usePayloadTask()
    // Never seed task.minutes or task.frequency from the schedule here: copying them on render
    // silently created overrides that any later tailoring save persisted, pinning the task to
    // whatever the schedule said at that moment. Overrides must only be
    // written when the user edits a value; absent means "inherit from the schedule" (see
    // extend-schedule.mjs). The frequency editor shows the inherited value from a draft of its own
    // and writes to the payload only once the user moves the interval or the period.
    const refresh = useRefresh()
    return (
        <Payload>
            <BlockClicks>
                <Bound onChange={validate} editMode={true} target={task}>
                    {/* No onRevert handler is needed on either field: Different now removes the key
                        itself rather than writing a copy of the inherited value, so reverting leaves
                        no override behind for any field, not only these two. */}
                    <Different field="minutes" comparedTo={target}>
                        <Time />
                    </Different>
                    <Different field="frequency" comparedTo={target}>
                        <Frequency />
                    </Different>
                </Bound>
            </BlockClicks>
        </Payload>
    )

    function validate() {
        if (periodDuration(task) < periodDuration(target) && target.classification === "Red") {
            errorSnackbar("You can't extend the original red task frequency")
            // Rejecting the edit means falling back to the master frequency — remove the override
            // rather than writing a copy of the master value, which would pin it.
            delete task.frequency
            refresh()
        }
        assessStatus(payload, schedule)
        SummaryDataChanged.raiseOnce()
        TaskTailorChange.raiseOnce({ payload, taskId: target.id })
    }
}
